import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {runGuestPickerAgeofChildrenExperiment, runGuestPickerAriaRoleExperiment} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultGuestsOptions = {
    actionLocation: undef,
    adultsMax: undef,
    adultsMin: undef,
    ageOptions: {
        minValue: 0,
        maxValue: 17,
        minAge: undef,
        undefAgesValue: {
            value: '-',
            label: '-',
            disabled: true,
        },
        useUndefAges: true,
    },
    allowErrorHighlighting: undef,
    autoSubmit: undef,
    centered: undef,
    childrenMax: undef,
    childrenMin: undef,
    disableTextInput: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'guests',
    inputIconName: 'group',
    isAriaRoleExperimentEnabled: undef,
    name: 'guests',
    placement: 'bottom',
    positionIconRight: undef,
    showAgeRanges: undef,
    showAgeSelect: undef,
    showClearButton: false,
    showContinue: undef,
    showInputIcon: undef,
    showPetOption: true,
    wdioPrefix: undef
};

function useGuestsOptions(props, abacusStore) {
    const {
        guestsOptions: propsGuestsOptions
    } = props;

    const showAgeSelectExperiment = runGuestPickerAgeofChildrenExperiment({shouldLogExperiment: false}, abacusStore) || undef;

    const experimentGuestsOptions = {
        isAriaRoleExperimentEnabled: runGuestPickerAriaRoleExperiment({shouldLogExperiment: true}, abacusStore) || undef,
        showAgeRanges: showAgeSelectExperiment,
        showAgeSelect: showAgeSelectExperiment
    };

    const {
        options: guestsOptions
    } = useOptions(defaultGuestsOptions, experimentGuestsOptions, propsGuestsOptions);

    const result = {
        guestsOptions
    };

    useDebugValue(result);

    return result;
}

export {useGuestsOptions};
